import React from "react";
export default React.createContext({
   isFullscreen: false,
   setFullscreen: () => {},
});
